"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCoreSelectionsSyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const state_1 = require("./state.js");
exports.removeCoreSelectionsSyncSlice = (0, xuder_1.createRemoveSyncSlice)({
    name: name_1.CoreSelectionsName,
    state: state_1.defaultSelectionState,
    transform: (action, state = {}) => {
        var _a, _b;
        const namespace = (_a = action === null || action === void 0 ? void 0 : action.namespace) !== null && _a !== void 0 ? _a : 'global';
        const selections = (_b = action === null || action === void 0 ? void 0 : action.selections) !== null && _b !== void 0 ? _b : [];
        if (selections.length === 0) {
            state[namespace] = {};
        }
        else {
            selections.forEach((id) => {
                delete state[namespace][id];
            });
        }
        return state;
    }
});
//# sourceMappingURL=remove.js.map